<div class="modal-header">
  <div>
    <h5 class="modal-title mb-0">
      {{ mode === 'create' ? 'New Template' : 'Edit Template' }}
    </h5>
    <small class="text-muted">
      {{ mode === 'create'
        ? 'Create a reusable email template.'
        : 'Update this email template.' }}
    </small>
  </div>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-7 mb-3">
        <label for="TEMPLATE_NAME">Template Name</label>
        <input
          id="TEMPLATE_NAME"
          type="text"
          class="form-control"
          formControlName="name"
          placeholder="Standard Invoice Email"
        />

        <small
          class="text-danger"
          *ngIf="form.controls.name.touched && form.controls.name.invalid"
        >
          Template name is required.
        </small>
      </div>

      <div class="col-md-5 mb-3">
        <label for="TEMPLATE_TYPE">Template Type</label>
        <select
          id="TEMPLATE_TYPE"
          class="form-select"
          formControlName="type"
        >
          <option
            *ngFor="let type of templateTypes"
            [value]="type.value"
          >
            {{ type.label }}
          </option>
        </select>
      </div>
    </div>

    <div class="mb-3">
      <label for="TEMPLATE_SUBJECT">Subject</label>
      <input
        id="TEMPLATE_SUBJECT"
        type="text"
        class="form-control"
        formControlName="subject"
        placeholder="Your invoice from Acme Co."
      />

      <small
        class="text-danger"
        *ngIf="form.controls.subject.touched && form.controls.subject.invalid"
      >
        Subject is required.
      </small>
    </div>

    <div class="mb-3">
      <div class="form-check">
        <input
          id="TEMPLATE_DEFAULT"
          type="checkbox"
          class="form-check-input"
          formControlName="isDefault"
          [disabled]="mode === 'edit' && template?.isDefault === true"
        />

        <label
          for="TEMPLATE_DEFAULT"
          class="form-check-label"
        >
          Set as default for this type
        </label>
      </div>
    </div>

    <div>
      <label for="TEMPLATE_BODY">Body</label>

      <quill-editor
        id="TEMPLATE_BODY"
        class="quill-editor"
        [sanitize]="true"
        formControlName="body"
        [styles]="{ height: '300px' }"
      ></quill-editor>

      <small
        class="text-danger"
        *ngIf="form.controls.body.touched && form.controls.body.invalid"
      >
        Body is required.
      </small>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="cancel()"
  >
    Cancel
  </button>

  <button
    type="button"
    class="btn btn-primary"
    (click)="save()"
  >
    {{ mode === 'create' ? 'Create Template' : 'Save Changes' }}
  </button>
</div>